<template>
  <a class="header__shopCard order-7" :href="route"><span
          class="header__counter header__shopCard-counter" v-if="list.length">{{list.length}}</span></a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['route'],
  name: 'ShopCardHeaderButton',
  computed: {
    ...mapGetters('shop_card',['list'])
  }
}
</script>

<style scoped>

</style>
